import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import "./assets/scss/style.scss";
import "./assets/scss/v2/style.scss";
import 'animate.css';
import "quill/dist/quill.core.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthenticationProvider } from './providers/AuthenticationProvider';
import ResponseHandler from './wrapper/AxiosWrapper';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import CssBaseline from '@mui/material/CssBaseline';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <GoogleOAuthProvider clientId='828536784854-sdcb0g809ekpqtbm2mfpi4f6bjh3ikr5.apps.googleusercontent.com'>
      <AuthenticationProvider>
        <ResponseHandler>
          <App />
        </ResponseHandler>
      </AuthenticationProvider>
    </GoogleOAuthProvider>
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
